const createFloorPlan = function(designRoomId, roomCount) {
  return {
    design_room_id: Number(designRoomId),
    count_room: Number(roomCount)
  }
}

const getFloorPlanAttributesZeroCount = function(roomInner, floorPlanAttributesArray) {
  return roomInner.reduce((acc, { design_room_id: id }) => {
    const isRoomAttributeExist = floorPlanAttributesArray.find(({ design_room_id }) => design_room_id === id)

    if (!isRoomAttributeExist) {
      acc.push(createFloorPlan(id, 0))
    }

    return acc
  }, [])
}

const getFloorPlanAttributes = function(floorPlan, roomInner) {
  return floorPlan.floorplan_rooms_attributes.map((item) => {
    const floorPlanAttributesArray = []

    for (const [key, value] of Object.entries(item)) {
      floorPlanAttributesArray.push(createFloorPlan(key, value))
    }

    const floorPlanAttributesZeroCount = getFloorPlanAttributesZeroCount(roomInner, floorPlanAttributesArray)

    return floorPlanAttributesArray.concat(floorPlanAttributesZeroCount)
  })
}

export default function(values, roomInner) {
  const data = { floorplan_rooms_attributes: [] }

  for (const [key, value] of Object.entries(values)) {

    if (key === "floorplan_rooms_attributes") {
      const attributes = getFloorPlanAttributes(values, roomInner)
      data[key] = attributes[0]
    }
    else {
      data[key] = value
    }
  }

  return data
}
